import { initialState } from "./selectors";
import { GET_QUIZ_REQUEST, GET_QUIZ_SUCCESS, ANSWER_QUIZ_REQUEST, ANSWER_QUIZ_SUCCESS } from "./actions";

export default function brand(state = initialState, action = {}) {
  const { type, payload } = action;
  switch (type) {
    case GET_QUIZ_REQUEST:
      return {
        ...state,
      };
    case GET_QUIZ_SUCCESS:
      return {
        ...state,
        quiz: payload,
      };
    case ANSWER_QUIZ_REQUEST:
      return {
        ...state,
      };
    case ANSWER_QUIZ_SUCCESS:
      const unAnswered = [...state.quiz.unAnswered.filter(q => q._id !== payload.question._id)];
      const hidden = [...state.quiz.hidden.filter(q => q._id !== payload.question._id)];
      const answered = [...state.quiz.answered, payload.answer];
      return {
        ...state,
        quiz: { hidden, unAnswered, answered },
      };
    default:
      return state;
  }
}
